var VehicleSelector = VehicleSelector || {};
 
VehicleSelector = {
    vehicleRequestURL: '/includes/vehicleMap.cgi?vehicleSelection=1',
    vehicleURLStep: 'vstep_',
    vehicleSteps: {},
    stepsToSelect: [],
    
    /**
     * Get next step based on an object of steps.
     *
     * @param object     steps {step.1: value, step.2: value}
     * @param function   callback (receives data as parameter)
     *
     * @return callback/void
     */
    getNextStep: function(callback) {
        var totalSteps = this.vehicleSteps.length; // See how many steps were passed to build the URL.
        var vehicleURLFinal = this.vehicleRequestURL;
        var self = this;
        
        // Loop through them and build the URL request.
        $.each(this.vehicleSteps, function(index, step) {
            vehicleURLFinal += '&' + index + '=' + encodeURIComponent(step);
        });
        
        // Make the request.
        $.ajax({
            'url'      : vehicleURLFinal,
            'type'     : 'GET',
            'dataType' : 'text',
        })
        .done(function(data) {
            callback(self.parseVehicleData(data));
        });
    },
    
    /**
     * Parse vehicle data from server.
     *
     * @param string data
     *
     * @return object/null
     */
    parseVehicleData: function(data) {
        var line = data.split('\n');
        
        // Store the steps that need to be generated
        var createdSteps = [];
        var options = 0;
        var currentStep = null;
        var currentStepNum = null;
        
        // Parse the AJAX response
        for (var i = 0; i < line.length; i++) {
            // If there are no characters, skip through this one.
    		if (! line[i].length) {
                continue;
            }
            
            // Data format: vstep_2::90 Series::90 Series
            var lineElements = line[i].split('::');
            var currentLine = lineElements[0];
            var currentLineValue = lineElements[2];
            var currentLineDisplay = lineElements[1];
            
            // If this is the end of all available options, let's break out of the loop
            if (currentLine == 'END') {
                break;
            }
            
            // There are more options so let's compile them in a neat format!
            if (currentLine !== currentStep) {
                // This line is not logged in our currentSteps array so let's put it there!
                options = 0; // Reset counter
                currentStepNum = (currentStepNum === null ? 0 : currentStepNum + 1);
                currentStep = currentLine;
                
                createdSteps[currentStepNum] = {
                    key: currentStep,
                    options: []
                };
            }
            
            // Let's put the options in there now.
            if (currentLineValue === 'n') {
                // This is the label of the options.
                createdSteps[currentStepNum].label = currentLineDisplay;
            } else {
                createdSteps[currentStepNum].options.push({
                    val: currentLineValue,
                    label: currentLineDisplay
                });
            }
            options++;
        }
        
        return createdSteps;
    },
    
    /**
     * Add vehicle step to object.
     *
     * @param int    step
     * @param string value
     *
     * @return object
     */
    addStep: function(step, value) {
        this.vehicleSteps[this.vehicleURLStep + step] = value;
        
        return this.vehicleSteps;
    },
    
    /**
     * Remove vehicle step from object.
     *
     * @param int    step
     *
     * @return object
     */
    removeStep: function(step) {
        delete this.vehicleSteps[this.vehicleURLStep + step];
        
        return this.vehicleSteps;
    },
    
    /**
     * Get all current steps.
     *
     * @return object
     */
    getSteps: function() {
        return this.vehicleSteps;
    },
    
    /**
     * Convert url step to integer
     *
     * @param string vstep
     *
     * @return int
     */
    convertUrlStepToInt: function(vstep) {
        return parseInt(vstep.split('_')[1], 10);
    },
    
    /**
     * Reset steps.
     *
     * @return void
     */
    resetSteps: function() {
        this.vehicleSteps = {};
    }
};
